import AboutUsContent from "@/components/shared/AboutUsContent";
import HowLifeWorksContent from "@/components/shared/HowLifeWorksContent";
import PrivacyPolicyContent from "@/components/shared/PrivacyPolicyContent";
import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";

export default function LifeInfoAccordion() {
  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">How Life Works</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <HowLifeWorksContent />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">About Us</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AboutUsContent />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <Typography component="span">Life Privacy Policy</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <PrivacyPolicyContent />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
